exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".children-652810ae{display:inline-block;padding:20px}.blockImg-35e1bc4a{max-width:100%}.empty-bf1f77c4{height:100px}.contents-7019eaea{display:inline-block;float:left}.actions-267fffdb{display:flex;justify-content:center}.actions-267fffdb>a:first-child{padding-right:20px}\n", ""]);

// Exports
exports.locals = {
	"children": "children-652810ae",
	"blockImg": "blockImg-35e1bc4a",
	"empty": "empty-bf1f77c4",
	"contents": "contents-7019eaea",
	"actions": "actions-267fffdb"
};